import axios from 'axios'

export const fetchProfiles = (limit: number, offset: number, sid: string) =>
  axios.get(`/profiles?limit=${limit}&offset=${offset}&sid=${sid}`)

export const getPhotofromId = (entityId: string) => axios.get(`/photo/${entityId}`)
